import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const MailLetter: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[1.666px]', className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3332 5.00001C18.3332 4.08334 17.5832 3.33334 16.6665 3.33334H3.33317C2.4165 3.33334 1.6665 4.08334 1.6665 5.00001M18.3332 5.00001V15C18.3332 15.9167 17.5832 16.6667 16.6665 16.6667H3.33317C2.4165 16.6667 1.6665 15.9167 1.6665 15V5.00001M18.3332 5.00001L9.99984 10.8333L1.6665 5.00001"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MailLetter;
